import { render, staticRenderFns } from "./Ammunition.vue?vue&type=template&id=7be19257&"
import script from "./Ammunition.vue?vue&type=script&lang=ts&"
export * from "./Ammunition.vue?vue&type=script&lang=ts&"
import style0 from "./Ammunition.vue?vue&type=style&index=0&id=7be19257&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports